import lodash from "lodash";
import Vue from "vue";
/** PagesEnum 自动生成请勿修改  */ 
/** @InjectPages **/ 
export const PagesEnum= {
    /** pages/index/index  */ 
    Index:{name:'index'}
}
/** @InjectPages **/
lodash.set(Vue, '$Pages', PagesEnum)
Object.defineProperty(Vue.prototype, "$Pages", {
    get: lodash.constant(PagesEnum),
});
declare module 'vue/types/vue' {
    interface Vue {
        $Pages: typeof PagesEnum
    }
    interface VueConstructor<V extends Vue = Vue> {
        $Pages: typeof PagesEnum
    }
}